import Image from "next/image";
import { Typography } from "@drpcrd/shared/ui";

type Props = {
  name: string;
  handle: string;
  avatarSrc: string;
};

/**
 * Avatar, brand name, and mission handle for a Baked with Nutcake creator card.
 * Uses local static images, bypassing CDN resolution.
 */
export const BakedCreatorInfo = ({ name, handle, avatarSrc }: Props) => (
  <div className="flex items-center gap-1.5">
    <Image
      src={avatarSrc}
      alt={name}
      width={40}
      height={40}
      className="h-4 w-4 shrink-0 rounded-full sm:h-5 sm:w-5"
    />
    <div className="flex min-w-0 flex-col">
      <Typography
        weight="semibold"
        className="text-sm sm:text-base"
        color="black"
      >
        {name}
      </Typography>
      <Typography className="text-dark text-xs sm:text-sm">{handle}</Typography>
    </div>
  </div>
);
